const Newsletter = function () {
    const _handleNewsletterPopup = function () {
        let stickyBtnClosed = false;

        if (window.sessionStorage.getItem('newsletterNbPageVisited') < 2) {
            if (!stickyBtnClosed) {
                let newsletterNbPageVisited = parseInt(window.sessionStorage.getItem('newsletterNbPageVisited')) || 0;
                window.sessionStorage.setItem('newsletterNbPageVisited', newsletterNbPageVisited + 1);
            }
        }

        $('.sticky-newsletter-btn').click(function () {
            pushDataLayerNewsletterStickyBtnDisplay();
            _displayNewsletterPopup();
        });

        $('#closeStickyNewsletterBtn').click(function () {
            pushDataLayerNewsletterStickyBtnClose();
            window.sessionStorage.setItem('newsletterNbPageVisited', 2);
            $('.sticky-newsletter-btn-container').hide();
            stickyBtnClosed = true;

        });
    };

    const _displayNewsletterPopup = function () {
        let $newsletterPopUpContainer = $('#newsletter-popup-container');
        pushDataLayerNewsletterPopupDisplay();

        if ($newsletterPopUpContainer.hasClass('remodal-is-closed')) {
            $newsletterPopUpContainer.remodal().open();
        }
    };

    const _isNewsletterBtnAllowedOnPage = function () {
        let currentUrl = window.location.pathname;

        return typeof homePageUrl !== 'undefined' && currentUrl !== homePageUrl
            && typeof shopOnlineUrl !== 'undefined' && currentUrl !== shopOnlineUrl
            && !isInCheckoutPage()
            && !TINK.matchMediaMobileTablet();
    };

    return {
        handleNewsletterPopup: _handleNewsletterPopup,
        isNewsletterBtnAllowedOnPage: _isNewsletterBtnAllowedOnPage
    };
}();

jQuery(document).ready(function () {
    var $newsletterDivExists = $('.newsletter-box-wrapper').length;
    if ($newsletterDivExists && Newsletter.isNewsletterBtnAllowedOnPage()) {
        $(window).on('scroll', _.throttle(function () {
            var scroll = $(window).scrollTop();
            if (scroll >= 150) {
                $('.sticky-newsletter-btn-container').addClass('active-newsletter-btn');
            } else {
                $('.sticky-newsletter-btn-container').removeClass('active-newsletter-btn');
            }
        }, 100));
        Newsletter.handleNewsletterPopup();
    }
});